import SaveSearch from '../SaveSearch/SaveSearch';
import JobMailWrapper from '../JobMail/JobMailWrapper';
import type { JobMailPosition } from 'src/store/saveSearch/saveSearch';

interface Props {
  authenticated: boolean;
  position: JobMailPosition;
}

const SavePanel = (props: Props) => {
  const { position, authenticated } = props;

  if (!authenticated) {
    return <JobMailWrapper position={position} />;
  }
  return position === 'top' ? <SaveSearch /> : null;
};

export default SavePanel;
